import request from "@/utils/request";

/**
 * 特色项目接口
 *
 */
export function api() {
  return {
    getList: () => {
      return request({
        url: "/website/featureProject/front/list",
        method: "get",
      });
    },
    getDetail: (id) => {
      return request({
        url: "/website/featureProject/front/detail",
        method: "get",
        params: {
          id,
        },
      });
    },
    getOther: (id) => {
      return request({
        url: "/website/featureProject/front/randomNews",
        method: "get",
        params: {
          id,
        },
      });
    },
    getAll: (id) => {
      return request({
        url: "/website/featureProject/front/all",
        method: "get",
      });
    },
  };
}
